import gradHeadshot from './../images/gradHeadshot.jpg'
import drewPf from './../images/drewPf.jpg'
import drewTrombone from  './../images/IMG_0958.jpg'


export const mastImages = [
    gradHeadshot, drewPf, drewTrombone
]